export const MAX_UINT =
  115792089237316195423570985008687907853269984665640564039457584007913129639935n;

// allows for unlimited slippage
export const MIN_SQRT_PRICE_LIMIT = 4295128739n + 1n;
export const MAX_SQRT_PRICE_LIMIT = 1461446703485210103287273052203988822378723970342n - 1n;

export const ZERO_ADDR = '0x0000000000000000000000000000000000000000';

export const BLANK_TOKEN = {
  address: '0x000000000000000000000000000000000000dEaD',
  symbol: 'BLANK',
  name: 'BLANK',
  decimals: 18,
  totalSupply: { formatted: '0', value: 0n },
};

// used in liquidity amount math
export const Q96 = BigInt(2) ** BigInt(96);
export const Q192 = Q96 ** BigInt(2);
export const Q128 = BigInt(2) ** BigInt(128);
export const ZERO = BigInt(0);
export const ONE = BigInt(1);
export const TWO = BigInt(2);
export const MaxUint256 = BigInt(
  '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff',
);

export const POWERS_OF_2 = [128, 64, 32, 16, 8, 4, 2, 1].map((pow: number): [number, bigint] => [
  pow,
  TWO ** BigInt(pow),
]);

// 1e18
export const PRICE_SCALE = BigInt(10) ** BigInt(18);

// Default max slippage percent of 0.5% in bps
export const DEFAULT_MAX_SLIPPAGE_PERCENT = 50n;
